import { FEATURE_IDS, FEATURE_STATUS, UDV_PLANS } from './constants'

const { LITE, PRO, PREMIUM } = UDV_PLANS
const { DRAFT, PUBLISHED } = FEATURE_STATUS

/**
 * @typedef {{ id: string, label: string, status: 'draft'|'published', plans: string[] }} PlanFeature
 */

/**
 * Matriz comercial.
 * Plan `demo` / `patient`: sin features avanzadas (solo visor 2D básico — no listadas aquí).
 *
 * @type {PlanFeature[]}
 */
export const CATALOG_DEFAULTS = [
  {
    id: FEATURE_IDS.MPR,
    label: 'MPR ortogonal',
    status: PUBLISHED,
    plans: [LITE, PRO, PREMIUM],
  },
  {
    id: FEATURE_IDS.MPR_SLAB,
    label: 'MPR slab (MIP/MinIP)',
    status: PUBLISHED,
    plans: [PRO, PREMIUM],
  },
  {
    id: FEATURE_IDS.VOL3D,
    label: 'Vol3D',
    status: PUBLISHED,
    plans: [PRO, PREMIUM],
  },
  {
    id: FEATURE_IDS.PET_FUSION,
    label: 'Fusión PET',
    status: PUBLISHED,
    plans: [PREMIUM],
  },
  {
    id: FEATURE_IDS.DSA,
    label: 'DSA',
    status: PUBLISHED,
    plans: [PREMIUM],
  },
  {
    id: FEATURE_IDS.VOICE_NOTES,
    label: 'Notas de voz',
    status: PUBLISHED,
    plans: [PRO, PREMIUM],
  },
  {
    id: FEATURE_IDS.AI_COPILOT,
    label: 'UDV AI Copilot',
    status: PUBLISHED,
    plans: [PRO, PREMIUM],
  },
  {
    id: FEATURE_IDS.VOICE_WHISPER_LOCAL,
    label: 'Whisper local (STT)',
    status: DRAFT,
    plans: [],
  },
  {
    id: FEATURE_IDS.ANALYSIS_BODY_COMP,
    label: 'Body Comp (análisis)',
    status: DRAFT,
    plans: [],
  },
]
